// Redux action to show the environment info modal before deploy
export const showEnvironmentDeployInfoModal = () => ({});

// Redux action to update the current editing environment ID
export const setCurrentEditingEnvironmentID = (currentEditingId: string) => ({
  type: "",
  payload: { currentEditingId },
});
